import React from 'react';

import styles from './MobileOrderPage.module.css'

import {MobileOrderProducts} from "../../components/OrderProducts/Mobile/MobileOrderProducts.tsx";
import {MobileOrderDelivery} from "../../components/OrderDelivery/Mobile/MobileOrderDelivery.tsx";
import {OrderPaymentMethods} from "../../components/OrderPaymentMethods/OrderPaymentMethods.tsx";
import {Order} from "../../../../types/Order.interface.ts";

interface Props {
    orderOffer: Order,
    paymentMethod: string,
    onPaymentMethodChange: (variant: string) => void,
    getPaymentUrl: (orderId: number) => void,
}


export const MobileOrderPage: React.FC<Props> = ({
                                                        orderOffer,
                                                        onPaymentMethodChange,
                                                        getPaymentUrl,
                                                        paymentMethod,
                                                }) => {



    return (
        <div className={styles.wrapper}>
                <MobileOrderProducts
                    orderOffer={orderOffer}
                    getPaymentUrl={getPaymentUrl}
                />
                <MobileOrderDelivery
                    offer={orderOffer}
                />
                <OrderPaymentMethods onMethodChange={onPaymentMethodChange} orderOffer={orderOffer} paymentMethod={paymentMethod}/>
        </div>
    );
};